import React from "react";
import ReactDOM from "react-dom/client";
// import './index.css';
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { configureAmplify } from "./config/amplify-config";
import { initializeSentry } from "./lib/sentry";

// Configure Amplify and Sentry before rendering the app
async function initializeApp() {
  try {
    console.log('Initializing Amplify...');
    configureAmplify();
    console.log('Amplify configured successfully');
    
    console.log('Initializing Sentry...');
    initializeSentry();
    console.log('Sentry initialized successfully');
  } catch (error) {
    console.error('Failed to initialize services:', error);
  } finally {
    // Render the app regardless of initialization success/failure
    console.log('Rendering React app...');
    const root = ReactDOM.createRoot(
      document.getElementById("root") as HTMLElement
    );
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }
}

// Start the initialization process
initializeApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
